module.exports = require("././angular-translate.js");


/*****************
 ** WEBPACK FOOTER
 ** angular-translate (bower component)
 ** module id = 158
 ** module chunks = 0
 **/